import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  playlistRailWrapper: {
    height: Theme.appHeight,
    width: Theme.appWidth,
  },
  infoWrapper: {
    alignSelf: 'center',
    flexDirection: 'row',
  },
  scrolldownText: {
    color: Theme.suvaGrey,
    marginBottom: Theme.px(35),
  },
  arrowDownIcon: {
    height: Theme.px(26),
    marginHorizontal: Theme.px(18),
    marginTop: Theme.px(3),
    transform: [{ rotate: '-90deg' }],
    width: Theme.px(15),
  },
  railTitleText: {
    marginBottom: Theme.px(19),
    marginLeft: Theme.px(90),
  },
});
